'use client';

const CLIENT_SDK_WAIT_ATTEMPTS = 40;
const CLIENT_SDK_WAIT_MS = 250;

const waitForBootstrapValue = async <T>(readValue: () => T | undefined): Promise<T | undefined> => {
    const browserWindow = window as BrowserWindow;

    for (let attempt = 0; attempt < CLIENT_SDK_WAIT_ATTEMPTS; attempt += 1) {
        const value = readValue();

        if (value) {
            return value;
        }

        await browserWindow.__clientSdkBootstrapPromise?.catch(() => undefined);

        const bootstrapValue = readValue();

        if (bootstrapValue) {
            return bootstrapValue;
        }

        await new Promise((resolve) => {
            window.setTimeout(resolve, CLIENT_SDK_WAIT_MS);
        });
    }

    return undefined;
};

export const getClientSdk = async () =>
    waitForBootstrapValue(() => {
        const browserWindow = window as BrowserWindow;

        return browserWindow.clientSdk;
    });

export const getMicroservicesBaseUrl = async () =>
    waitForBootstrapValue(() => {
        const browserWindow = window as BrowserWindow;

        return browserWindow.microservicesClient?.baseUrl;
    });

export const getMicroservicesClient = async () =>
    waitForBootstrapValue(() => {
        const browserWindow = window as BrowserWindow;

        return browserWindow.microservicesClient;
    });
